import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import { SMOOTHED_RENT_GRADIENT_LEGEND } from '../../../constants/legends';

/**
 * AggHexRentLegend - Легенда персентилей средней цены за кв.м
 * Мигрирована на новую систему легенд (Этап 3)
 * Использует GradientLegend компонент через LegendRenderer
 */

const AggHexRentLegendComponent = () => (
    <LegendRenderer config={SMOOTHED_RENT_GRADIENT_LEGEND} />
);

export const AggHexRentLegend = withDisplayedLayersCheck(
    AggHexRentLegendComponent,
    t`Сглаженные показатели аренды`
);

